import { useNavigate } from 'react-router';
import socketIOClient from 'socket.io-client';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  Alert,
  AlertDescription,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertIcon,
  AlertTitle,
  Button,
  CloseButton,
  HStack,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { useURLParams } from './Utils/hooks/useURLParams';
import Loading from './Loading';
import { api } from 'api/api';

const { createContext, useState, useEffect, useCallback, useRef } = require('react');

export const AccountContext = createContext();

const UserContext = ({ children }) => {
  const { urlParams: webviewParams } = useURLParams();
  const [searchParams] = useSearchParams();
  const [clubeVantagens, setClubeItens] = useState([]);
  const toast = useToast();
  const navigate = useNavigate();
  const [loadedMedicina, setLoadingMedicina] = useState(false);
  const [isToastActive, setIsToastActive] = useState(false);
  const [page, setPage] = useState('Titulo da Pagina');
  const {
    isOpen: isAdmissionPaymentDialogOpen,
    onOpen: onOpenAdmissionPaymentDialog,
    onClose: onCloseAdmissionPaymentDialog,
  } = useDisclosure();
  const admissionPaymentDialogButtonRef = useRef(null);
  const [admissionPaymentDialog, setAdmissionPaymentDialog] = useState({
    title: 'Adesão confirmada',
    description: 'O Pagamento da adesão foi confirmada',
  });

  const handleSseEventExample = useCallback((payload) => {
    console.log('handleSseEventExample', payload);
    const nextPageTitle = payload?.payload?.pageTitle || payload?.pageTitle || 'Pagina atualizada via SSE';
    setPage(nextPageTitle);
    toast({
      title: 'SSE Event Example',
      description: `Contexto atualizado: ${nextPageTitle}`,
      status: 'info',
      duration: 3000,
      isClosable: true,
      position: 'top',
    });
    return true;
  }, [toast]);

  const handleAdmissionPaymentConfirmedEvent = useCallback(
    (payload) => {
      const normalizedPayload = payload?.payload || payload || {};
      setAdmissionPaymentDialog({
        title: normalizedPayload?.title,
        description:
          normalizedPayload?.description,
      });
      onOpenAdmissionPaymentDialog();
    },
    [onOpenAdmissionPaymentDialog],
  );

  const handleAdmissionPaymentDialogConfirm = useCallback(() => {
    onCloseAdmissionPaymentDialog();
    window.location.reload();
  }, [onCloseAdmissionPaymentDialog]);

  const toastInadimplente = (forma_pagamento, mensalidadesPendentes) => {
    let usuarioAssinante = user?.id_contrato && user?.descricao_plano ? true : false;
    if (user.titular === false) usuarioAssinante = true;

    if (!user?.loggedIn || !usuarioAssinante) {
      return;
    }

    const ENDPOINT =
      process.env.REACT_APP_ENVIRONMENT === 'production'
        ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
        : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
    const url = `${ENDPOINT}/client/parcelas`;

    async function fetchMensalidades() {
      setIsToastActive(false);
      toast.closeAll();
      const toastId = toast({
        title: 'Carregando',
        description: 'Aguarde... Estamos carregando as informações.',
        status: 'warning',
        isClosable: true,
        position: 'bottom',
        colorScheme: 'red',
        duration: null,
        type: 'loading',
        containerStyle: {
          paddingTop: '50px',
        },
      });

      try {
        const response = await api(url, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({
            id_contrato:
              user?.clienteImportado?.clientImportado === true
                ? user?.clienteImportado?.empreendedor?.contrato_id
                : user.titular
                  ? user.id_contrato
                  : user.id_contrato_dependent.paciente_contrato_id,
            titular: user.titular,
            id_contrato_dependente: user.id_contrato_dependent,
            adesaoImportada: user?.clienteImportado?.clientImportado,
          }),
        });

        const postsData = await response.json();
        toast.close(toastId);

        if (postsData?.length === 0) {
          navigate('/dashboard/financeiro/sucesso-pagamento');
        } else {
          navigate('/pagamentoparcelas');
        }
      } catch (error) {
        toast.close(toastId);
        console.error('Erro ao carregar mensalidades:', error);
      }
    }
    if (user?.loggedIn && user?.clienteImportado?.clientImportado) {
      return;
    }
    if (!isToastActive) {
      setIsToastActive(true);

      if (mensalidadesPendentes?.countParcelas > 0 && user?.pesquisaParcelasPendentes.length <= 0) {
        toast({
          position: 'bottom',
          onClose: () => setIsToastActive(false),
          duration: 30000000,
          isClosable: true,
          render: () => (
            <Alert
              status="error"
              variant="solid"
              flexDirection="column"
              onClick={() => {
                setIsToastActive(false);
              }}
              rounded="md"
            >
              <HStack w="100%">
                <AlertIcon />
                <AlertTitle w="80%" align="center">
                  Pendência Financeira Detectada
                </AlertTitle>
                <CloseButton alignSelf="flex-end" position="relative" right={-1} top={-1} onClick={() => toast.closeAll()} />
              </HStack>
              <AlertDescription
                maxWidth="sm"
                textAlign="justify"
                onClick={() => {
                  if (user.provedor !== null) return;
                  fetchMensalidades();
                }}
              >
                {user.provedor !== null
                  ? 'Para continuar aproveitando todos os benefícios do seu plano DeoVita, é necessário regularizar a situação.'
                  : 'Uma ou mais mensalidades do seu plano estão em atraso. Para continuar aproveitando todos os benefícios do seu plano DeoVita, é necessário regularizar a situação. Clique aqui para resolver agora e retomar o acesso aos nossos serviços.'}
              </AlertDescription>
            </Alert>
          ),
          containerStyle: {
            paddingBottom: '100px',
          },
        });
      } else if (mensalidadesPendentes?.countParcelas > 0 && user?.pesquisaParcelasPendentes.length > 0) {
        toast({
          position: 'bottom',
          onClose: () => setIsToastActive(false),
          duration: 30000000,
          isClosable: true,
          render: () => (
            <Alert
              status="error"
              variant="solid"
              flexDirection="column"
              bg={'#5AB2AE'}
              onClick={() => {
                setIsToastActive(false);
                //fetchMensalidades();
              }}
              rounded="md"
            >
              <HStack w="100%">
                <AlertIcon />
                <AlertTitle w="80%" align="center" color={'white'}>
                  Pagamento em processamento
                </AlertTitle>
                <CloseButton alignSelf="flex-end" position="relative" right={-1} top={-1} onClick={() => toast.closeAll()} />
              </HStack>
              <AlertDescription
                maxWidth="sm"
                textAlign="justify"
                color={'white'}
                onClick={() => {
                  fetchMensalidades();
                }}
              >
                Seu pagamento está sendo processado. Clique aqui para verificar a situação do seu pagamento.
              </AlertDescription>
            </Alert>
          ),
          containerStyle: {
            paddingBottom: '100px',
          },
        });
      }
    }
  };

  async function atualizarNotificacao() {
    const url = `${ENDPOINT}/clients/atualizarNotificacao`;
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ cpf: user.cpf }),
    });
    await response.json().then(async (data) => {
      const updatedUser = {
        ...user,
        solicitacoes_consulta: Object.fromEntries(
          Object.entries(user?.solicitacoes_consulta).map(([key, value]) => [key, { ...value, notificacao_app: true }]),
        ),
        solicitacoes: Object.fromEntries(Object.entries(user?.solicitacoes).map(([key, value]) => [key, { ...value, notificacao_app: true }])),
      };
      setUser(updatedUser);
    });
  }

  const toastSolicitacao = () => {
    toast({
      position: 'bottom',

      duration: 30000,
      isClosable: true,
      render: () => (
        <Alert
          status="info"
          variant="solid"
          flexDirection="column"
          onClick={() => {
            console.log('click');
          }}
          rounded="md"
        >
          <HStack w="100%">
            <AlertIcon />
            <AlertTitle w="80%" align="center">
              Prescrição Disponível
            </AlertTitle>
            <CloseButton
              alignSelf="flex-end"
              position="relative"
              right={-1}
              top={-1}
              onClick={() => {
                atualizarNotificacao();
                toast.closeAll();
              }}
            />
          </HStack>
          <AlertDescription
            maxWidth="sm"
            textAlign="justify"
            onClick={() => {
              toast.closeAll();
              navigate('/carrinho');
            }}
          >
            Seu Médico(a) prescreveu{' '}
            {user.qntde_solicitacoes_consulta > 0 && user.qntde_solicitacoes > 0
              ? 'alguns exames e consultas. '
              : user.qntde_solicitacoes_consulta > 0 && user.qntde_solicitacoes === 0
                ? 'algumas consultas'
                : 'alguns exames'}{' '}
            Clique aqui ou no ícone do carrinho de compras.
          </AlertDescription>
        </Alert>
      ),
      containerStyle: {
        paddingBottom: '100px',
      },
    });
  };
  const novaVersaoDisponivel = () => {
    toast({
      position: 'bottom',
      duration: 30000,
      isClosable: true,
      render: () => (
        <Alert bg={'#5AB2AE'} status="info" variant="solid" flexDirection="column" rounded="md" borderRadius={'0.8em'}>
          <HStack w="100%">
            <AlertTitle w="80%" align="left" fontSize="1.2em" fontWeight={'bold'}>
              Nova versão disponível!
            </AlertTitle>
          </HStack>
          <AlertDescription
            maxWidth="sm"
            textAlign="justify"
            fontSize="1em"
            onClick={() => {
              toast.closeAll();
              window.open('https://apps.apple.com/br/app/deovita/id1545985928', '_blank');
            }}
          >
            Clique aqui para atualizar o app para a última versão disponível em loja e aproveite!
          </AlertDescription>
        </Alert>
      ),
      containerStyle: {
        paddingBottom: '100px',
      },
    });
  };
  const ENDPOINT =
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
      : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
  const [socket, setSocket] = useState();
  // let device = 'ios';
  let url = window.location.href;
  const location = useLocation();

  useEffect(() => {
    const handleContextExample = (event) => {
      handleSseEventExample(event.detail);
    };

    window.addEventListener('sseContextExample', handleContextExample);

    return () => {
      window.removeEventListener('sseContextExample', handleContextExample);
    };
  }, [handleSseEventExample]);

  useEffect(() => {
    const handleAdmissionPaymentConfirmed = (event) => {
      handleAdmissionPaymentConfirmedEvent(event.detail);
    };

    window.addEventListener('sseAdmissionPaymentConfirmed', handleAdmissionPaymentConfirmed);

    return () => {
      window.removeEventListener('sseAdmissionPaymentConfirmed', handleAdmissionPaymentConfirmed);
    };
  }, [handleAdmissionPaymentConfirmedEvent]);

  // if (url.includes('android')) {
  //   device = 'android';
  // }
  useEffect(() => {
    setSocket(socketIOClient(ENDPOINT));
  }, [url]);

  const build = searchParams.get('build') ?? null;
  const device = searchParams.get('platform') ?? null;

  useEffect(() => {
    if (device == 'ios' && build != '38.5.20') {
      ////novaVersaoDisponivel();
    }
  }, [build, device]);
  useEffect(() => {
    let url = window.location.href;
    if (socket) {
      const schedulingFlow = url.includes('/atendimento/pedido') || url.includes('/pagamentos');
      if (schedulingFlow) !socket.connected && socket.connect();
      else socket.connected && socket.emit('unlockSchedule', true);
    }
  }, [socket, location.pathname]);

  const [pic, setPic] = useState('1');

  const [user, setUser] = useState({
    loggedIn: null,
    username: null,
    device: null,
    name: null,
    id_contrato: null,
    id_forma_pagamento: null,
    id_plano: null,
    phone1: null,
    phone2: null,
    phone3: null,
    cpf: null,
    rg: null,
    data_aniv: null,
    sexo: null,
    cep: null,
    logradouro: null,
    numero: null,
    complemento: null,
    bairro: null,
    cidade: null,
    uf: null,
    code_ibge: null,
    email: null,
    cod_enel: null,
    situacao: null,
    inicio_contrato: null,
    conciliado_rapidoc: null,
    id_rapidoc: null,
    id_cliente_deovita: null,
    qtde_max_dependentes: 0,
    qtde_max_dependentes_total: 0,
    taxa_remocao_dependente: null,
    cards: [],
    adicionais: [],
    adicionais_pendentes: [],
    popup_adicionais: true,
    avaliacao_pendente: false,
    empreendedor_popup: false,
    url: null,
    qrcode: null,
    coords: null,
    cart: null,
    cart_temp: null,
    titular: null,
    contrato_pendente_pagamento: null,
    pedido_pendente: null,
    recipient_id: null,
    qntdeParcelas: null,
    descricao_plano: '',
    solicitacoes_consulta: null,
    telemedicina: null,
    build: null,
    situacao_contrato: null,
  });

  async function cancelaContrato(user, pago, motivo) {
    setLoadingMedicina(true);
    const vals = {
      cliente_id: user.id_cliente_deovita,
      id_contrato: user.id_contrato,
      username: user.username,
      pago: pago,
      motivo: motivo,
    };

    try {
      const postsData = await api(`${ENDPOINT}/clients/cancela_contrato`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vals),
      });

      const response = await postsData.json();

      if (!response.success) {
        setLoadingMedicina(false);
        toast({
          title: 'Importante',
          description: 'Não foi possível concluir a solicitação. Tente novamente mais tarde.',
          status: 'warning',
          duration: 4000,
          isClosable: true,
          position: 'bottom',
          colorScheme: 'red',
          containerStyle: {
            paddingTop: '50px',
          },
        });
        return { success: false };
      }

      setLoadingMedicina(false);
      return { success: true };
    } catch (error) {
      console.error(error);
      setLoadingMedicina(false);
      throw new Error('Ocorreu um erro ao atualizar os dados.');
    }
  }

  useEffect(() => {
    const bearer = searchParams.get('bearer') ?? null;
    api(`${ENDPOINT}/auth/login`, {
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${bearer ?? ''}`,
      },
    })
      .catch((err) => {
        setUser((user) => {
          return { loggedIn: false, device: device, build: build };
        });
        return;
      })
      .then((r) => {
        if (!r || !r.ok || r.status >= 400) {
          setUser((user) => {
            return { loggedIn: false, device: device, build: build };
          });
          return;
        }
        return r.json();
      })
      .then((data) => {
        console.log('data:', data);
        if (!data) {
          setUser((user) => {
            return { loggedIn: false, device: device, build: build };
          });
          return;
        }
        const postMessageReactNative = {
          event: 'login',
          data: data,
        };
        if (bearer && bearer != '') {
          localStorage.setItem('token', bearer);
        }
        window?.ReactNativeWebView?.postMessage(JSON.stringify(postMessageReactNative));
        setUser({ ...data, device: device, build: build });
        if (data.id_contrato === 0 && data.titular === true) {
          console.log('data?.clienteImportado ', data?.clienteImportado);
          if (data?.clienteImportado?.clientImportado === true) {
            navigate('/dashboard');
            return;
          }

          if (data.contrato_pendente_pagamento === true) {
            navigate('/cadastro/analise', {
              state: {
                client_id: data.id_cliente_deovita,
                name: data.name,
                cpf: data.cpf,
              },
            });
          } else {
            navigate('/dashboard');
          }
        } else {
          navigate('/dashboard');
        }
      });
  }, []);

  async function updateData(user) {
    setLoadingMedicina(true);
    const vals = {
      cliente_id: user.id_cliente_deovita,
      id_contrato: user.id_contrato,
      username: user.username,
    };

    try {
      const postsData = await api(`${ENDPOINT}/auth/recoveryData`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vals),
      });

      const response = await postsData.json();

      if (!response.success) {
        setLoadingMedicina(false);
        toast({
          title: 'Importante',
          description: 'Não foi possível concluir a solicitação. Tente novamente mais tarde.',
          status: 'warning',
          duration: 4000,
          isClosable: true,
          position: 'bottom',
          colorScheme: 'red',
          containerStyle: {
            paddingTop: '50px',
          },
        });
        return { success: false };
      }
      console.log('response data updateData', response.data);
      setUser((prevState) => ({
        ...prevState,
        loggedIn: true,
        build: prevState.build ? prevState.build : null,
        ...response.data,
      }));
      setLoadingMedicina(false);
      return { success: true, ...response.data };
    } catch (error) {
      console.error(error);
      setLoadingMedicina(false);
      throw new Error('Ocorreu um erro ao atualizar os dados.');
    }
  }

  return (
    <AccountContext.Provider
      value={{
        user,
        setUser,
        page,
        setPage,
        pic,
        setPic,
        socket,
        toastInadimplente,
        toastSolicitacao,
        updateData,
        loadedMedicina,
        setLoadingMedicina,
        webviewParams,
        clubeVantagens,
        setClubeItens,
        cancelaContrato,
      }}
    >
      {children}
      <AlertDialog
        isOpen={isAdmissionPaymentDialogOpen}
        leastDestructiveRef={admissionPaymentDialogButtonRef}
        onClose={handleAdmissionPaymentDialogConfirm}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        isCentered={true}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {admissionPaymentDialog.title}
            </AlertDialogHeader>
            <AlertDialogBody>{admissionPaymentDialog.description}</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={admissionPaymentDialogButtonRef} colorScheme="teal" onClick={handleAdmissionPaymentDialogConfirm}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </AccountContext.Provider>
  );
};

export default UserContext;
